import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Button } from 'uiToolkitV1/Button';

const Footer = ({
  onClose,
  onClear,
  onSelect,
  selectDisabled,
  enableEmptyDateRangeToBeSelected = false,
  displayCancelButton = true,
  displayClearButton = true,
}) => {
  const isSelectButtonDisabled = enableEmptyDateRangeToBeSelected ? false : selectDisabled;
  return (
    <Flex w="100%" mt="12px" p="8px">
      {displayClearButton && (
        <Button variant="tertiary" onClick={onClear}>
          Clear
        </Button>
      )}

      <Flex ml="auto">
        {displayCancelButton && (
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        )}
        <Button
          ml="20px"
          onClick={() => {
            onSelect();
            onClose();
          }}
          disabled={isSelectButtonDisabled}
        >
          Select
        </Button>
      </Flex>
    </Flex>
  );
};

export { Footer };
